import React from 'react';
import { Edit2, FileText, Calendar, MapPin, Briefcase } from 'lucide-react';
import './GeneratedJDs.css'; // Make sure to import the CSS file

export default function GeneratedJDs({ jds, onEdit }) {
  
  // --- Helper: Format Date & Time ---
  const formatDateTime = (isoString) => {
    if (!isoString) return 'Just Now';
    try {
      const date = new Date(isoString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (error) {
      return isoString;
    }
  };

  // --- EMPTY STATE ---
  if (!jds || jds.length === 0) {
    return (
      <div className="generated-jds-wrapper">
        <div style={{ 
            height: '100%', display: 'flex', flexDirection: 'column', 
            alignItems: 'center', justifyContent: 'center', color: '#64748b' 
        }}>
          <div style={{ background: '#f1f5f9', padding: '20px', borderRadius: '50%', marginBottom: '20px' }}>
            <FileText size={40} style={{ opacity: 0.5, color: '#94a3b8' }} />
          </div>
          <h3 style={{ margin: '0 0 8px 0', color: '#0f172a' }}>No Job Descriptions Yet</h3>
          <p style={{ margin: 0 }}>Head over to the <strong>JD Generator</strong> to create one.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="generated-jds-wrapper">
      <div className="jds-table-container">
        <table className="modern-jds-table">
          <thead>
            <tr>
              <th style={{ width: '25%' }}>Job Role</th>
              <th style={{ width: '15%' }}>Experience</th>
              <th style={{ width: '25%' }}>Location</th>
              <th style={{ width: '20%' }}>Date Created</th>
              <th style={{ width: '15%', textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {jds.map((jd) => (
              <tr key={jd.id || jd._id}>
                {/* 1. Job Role & Hiring Type */}
                <td>
                  <div className="job-role-text">{jd.job_role}</div>
                  <span className={`hiring-badge ${jd.hiring_type || 'Full-time'}`}>
                    {jd.hiring_type || 'Full-time'}
                  </span>
                </td>

                {/* 2. Experience */}
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '500' }}>
                    <Briefcase size={14} color="#94a3b8" />
                    {jd.experience}
                  </div>
                </td>

                {/* 3. Location */}
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <MapPin size={14} color="#94a3b8" />
                    {jd.location}
                  </div>
                </td>

                {/* 4. Date Created */}
                <td>
                  <div className="date-wrapper">
                    <Calendar size={14} />
                    {formatDateTime(jd.dateCreated)}
                  </div>
                </td>

                {/* 5. Actions (Aligned Right) */}
                <td style={{ textAlign: 'right' }}>
                  <button className="edit-action-btn" onClick={() => onEdit(jd)}>
                    <Edit2 size={14} /> Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}